module.exports = __webpack_public_path__ + "static/media/ss1_preview.bd66e85e.jpg";